import { deepcopy, search_asp } from "../util";

const BR = /\<br\s*\/?\>/gi;

export function translateWrapText(tech, args, line, parsed, source, mapping, processed, config) {
  let rules = [];
  // do(wrap_text,L,T)
  let text_map = mapping[args[1]];
  let layer = source.layer?.[text_map?.layer];
  let text = layer?.text[text_map?.text];
  if (layer && text) {
    let rule = {
      category: "recommender",
      description: `Wrap ${text.type} for ${text.field}`,
      specifier: {
        role: { "on-mark": "mark.label", "on-axis": "axis.label", "legend": "legend" }[text.type],
        field: text.field
      },
      action: "modify",
      option: {
        width: 60
      }
    };
    if (layer.name) {
      rule.specifier.layer = { id: layer.name };
    } else {
      rule.specifier.layer = { index: text_map?.layer };
    }
    rules.push(rule);
  }
  return rules;
}

export function translateWrapTextBy(tech, args, line, parsed, source, mapping, processed, config) {
  let rules = [];
  // do(wrap_text_by,L,T,N)
  let text_map = mapping[args[1]];
  let layer = source.layer?.[text_map?.layer];
  let text = layer?.text[text_map?.text];
  let ratio = parseInt(args[2]) / 100;
  if (layer && text) {
    let rule = {
      category: "recommender",
      description: `${tech.startsWith('wrap') ? "Wrap" : "Unwrap"} ${text.type} for ${text.field}`,
      specifier: {
        role: { "on-mark": "mark.label", "on-axis": "axis.label", "legend": "legend" }[text.type],
        field: text.field
      },
      action: "modify",
      option: {
        width: {
          prod: ratio
        }
      }
    };
    if (layer.name) {
      rule.specifier.layer = { id: layer.name };
    } else {
      rule.specifier.layer = { index: text_map?.layer };
    }
    rules.push(rule);
  }
  return rules;
}

export function translateUnwrapText(tech, args, line, parsed, source, mapping, processed, config) {
  let rules = [];
  let text_map = mapping[args[1]];
  let layer = source.layer?.[text_map?.layer];
  let text = layer?.text[text_map?.text];
  if (layer && text) {
    let rule = {
      category: "recommender",
      description: `Unwrap ${text.type} for ${text.field}`,
      specifier: {
        role: { "on-mark": "mark.label", "on-axis": "axis.label", "legend": "legend" }[text.type],
        field: text.field
      },
      action: "modify",
      option: {
        width: null
      }
    }
    if (layer.name) {
      rule.specifier.layer = { id: layer.name };
    } else {
      rule.specifier.layer = { index: text_map?.layer };
    }
    rules.push(rule);
  }
  return rules;
}

export function translateRemoveText(tech, args, line, parsed, source, mapping, processed, config) {
  // do(remove_text,L,T).
  let rules = [];
  let text_map = mapping[args[1]];
  let layer = source.layer?.[text_map?.layer];
  let text = layer?.text[text_map?.text];
  if (layer && text) {
    let rule = {
      category: "recommender",
      description: `Remove ${text.type} for ${text.field}`,
      specifier: {
        role: { "on-mark": "mark.label", "on-axis": "axis.label", "legend": "legend" }[text.type],
        name: text.name,
        field: text.field
      },
      action: "remove"
    };
    if (layer.name) {
      rule.specifier.layer = { id: layer.name };
    } else {
      rule.specifier.layer = { index: text_map?.layer };
    }
    rules.push(rule);
  }
  return rules;
}

export function translateReduceTextSize(tech, args, line, parsed, source, mapping, processed, config) {
  // do(reduce_text_size,T).
  let rules = [];
  let text_map = mapping[args[0]];
  let layer = source.layer?.[text_map?.layer];
  let text = layer?.text[text_map?.text];
  let annoIndex = text_map.annotation;
  let scale_factor;
  search_asp(parsed, "do(disproportionate_resizing", "startsWith").forEach((p) => {
    scale_factor = source.layout.width / parseFloat(p.args[1]);
  });
  search_asp(parsed, "do(proportionate_resizing", "startsWith").forEach((p) => {
    scale_factor = source.layout.width / parseFloat(p.args[1]);
  });
  let isHeader = (source.layout?.row?.length == 2 && source.layout.row[0].field === text.field) || (source.layout?.column?.length == 2 && source.layout.column[0].field === text.field);
  let minFontSize = (isHeader ? 14 : 12);
  if (scale_factor && layer && text) {
    let rule = {
      category: "recommender",
      description: `Resize ${text.type} for ${text.field}`,
      specifier: {
        role: { "on-mark": "mark.label", "on-axis": "axis.label", "legend": "legend" }[text.type],
        field: text.field
      },
      action: "modify"
    };
    rule.option = {};
    if (text.items) {
      rule.option.items = text.items.map((item, index) => { return { index, fontSize: Math.max((item.fontSize || 16) / scale_factor, minFontSize) } });
    }
    if ((text.type === "legend" || text.type === "on-axis") && text.title) {
      rule.option.title = {
        fontSize: Math.max((text.title.fontSize || 16) / scale_factor, minFontSize)
      };
    }
    if (layer.name) {
      rule.specifier.layer = { id: layer.name };
    } else {
      rule.specifier.layer = { index: text_map?.layer };
    }
    rules.push(rule);
  } else if (scale_factor && annoIndex) {
    let annotation = source.annotation?.items?.[parseInt(annoIndex)];
    if (annotation) {
      let rule = {
        category: "recommender",
        description: `Resize annotation for ${annotation.name || ""}`,
        specifier: {
          role: "annotation"
        },
        action: "modify"
      };
      if (annotation.text) {
        rule.option = {};
        rule.option.fontSize = Math.max((annotation.text[0].fontSize || 16) / scale_factor, 12)
      }
      if (annotation.width && annotation.axisAssist) {
        rule.option.width = (annotation.width * rule.option.fontSize / (annotation.text[0].fontSize || 16));
      }
      if (annotation.name) {
        rule.specifier.id = annotation.name;
      }
      rules.push(rule);
    }
  } else if (scale_factor && text_map.type === "split.label") {
    let pr;
    if ((pr = search_asp(parsed, "do(make_heatmap_adjust_split", "startsWith")[0], pr?.args[1] === "keep_multiple" || !pr)) {
      let rule = {
        category: "recommender",
        description: `Resize split headers`,
        specifier: {
          role: "facet.label"
        },
        action: "modify",
        option: {
        }
      };
      if (source.layout?.split?.label?.items?.length > 0) {
        rule.option.items = source.layout?.split?.label?.items.map((d, index) => {
          return { index, fontSize: Math.max((d.fontSize || 16) / scale_factor, 14) }
        })
      } else {
        rule.option.fontSzie = Math.max((source.layout?.split?.label?.fontSize || 16) / scale_factor, 14);
      }
      rules.push(rule);
    } else if (pr?.args[1] === "to_row") {
      let rule = {
        category: "recommender",
        description: `Resize axis labels (converted from multiples headers)`,
        specifier: {
          role: "axis.label",
          field: source.layout?.split?.field
        },
        action: "modify",
        option: {
        }
      };
      if (source.layout?.split?.label?.items?.length > 0) {
        rule.option.items = source.layout?.split?.label?.items.map((d, index) => {
          return { index, fontSize: Math.max((d.fontSize || 16) / scale_factor, 14) }
        })
      } else {
        rule.option.fontSzie = Math.max((source.layout?.split?.label?.fontSize || 16) / scale_factor, 14);
      }
      rules.push(rule);
    }
  }
  return rules;
}

export function translateUnwrapBrText(tech, args, line, parsed, source, mapping, processed, config) {
  // do(reduce_text_size,T).
  let rules = [];
  let rule = {
    category: "recommender",
    description: `Unwrap text for `,
    specifier: {
    },
    action: "modify",
    option: {
    }
  }

  let text_map = mapping[args[0]];
  let layer = source.layer?.[text_map?.layer];
  let text = layer?.text[text_map?.text];

  let text_item;
  if (text_map.type === "split.label") {
    rule.specifier.role = "facet.label";
    text_item = source.layout.split?.label;
    if (args[1] === "converted_to_axis_row") {
      rule.specifier.role = "axis.label";
      rule.specifier.field = source.layout?.split?.field;
    }
  } else if (text) {
    rule.specifier.role = { "on-mark": "mark.label", "on-axis": "axis.label", "legend": "legend" }[text.type];
    if (text.name) rule.specifier.id = text.name;
    else if (text.field) rule.specifier.field = text.field;
    else rule.specifier.index = parseInt(text_map.text);
    if (layer) {
      rule.specifier.layer = {};
      if (layer.name) rule.specifier.layer.id = layer.name;
      else if (layer.mark?.type) rule.specifier.layer.mark = layer.mark.type;
      else rule.specifier.layer.index = text_map.layer;
    }
    text_item = text;
  }

  if (text_item) {
    rule.option.items = text_item.items?.map((_elem) => {
      let elem = {}
      if (isValue(_elem.text, "String")) {
        elem.text = _elem.text.replace(BR, " ");
      }
      if (isValue(_elem.expression, "String")) {
        elem.expression = _elem.expression.replace(BR, " ");
      }
      if (isValue(_elem.custom)) {
        elem.custom = {};
        Object.keys(_elem.custom).forEach((c) => {
          if (isValue(_elem.custom[c], "String")) {
            elem.custom[c] = _elem.custom[c].replace(BR, " ");
          }
        });
      }
      return elem;
    });
    rules.push(rule);
  }
  return rules;
}

function isValue(d, t) {
  if (t == undefined) return d !== undefined && d !== null;
  else return d?.constructor?.name === t;
}

export function translateSimplifyTextMinMaxSplit(tech, args, line, parsed, source, mapping, processed, config) {
  // do(simplify_text_min_max_split,T)
  let rules = [];
  let text_map = mapping[args[0]];
  let layer = source.layer?.[text_map?.layer];
  let text = layer?.text[text_map?.text];

  let rule = {
    category: "recommender",
    description: `Simplify axis lables after splitting`,
    specifier: {
      role: "axis.label"
    },
    action: "modify",
    option: {
    }
  }
  if (text) {
    if (text.name) rule.specifier.id = text.name;
    else if (text.field) rule.specifier.field = text.field;
    else rule.specifier.index = parseInt(text_map.text);
    if (layer) {
      rule.specifier.layer = {};
      if (layer.name) rule.specifier.layer.id = layer.name;
      else if (layer.mark?.type) rule.specifier.layer.mark = layer.mark.type;
      else rule.specifier.layer.index = text_map.layer;
    }
  }
  let values = text.values;
  if (!values) {
    values = source.datatype[text.field].values;
  }
  values = values.map(d => d).sort();
  rule.option.values = [values[0], values[values.length - 1]];
  rules.push(rule);
  if (text.items.length > 1) {
    let rule2 = {
      category: "recommender",
      description: `Simplify axis lables after splitting (Removal)`,
      specifier: deepcopy(rule.specifier),
      action: "remove",
      option: {
        items: { index: text.items.map((t, i) => (i == 0 ? undefined : i)).filter(d => d !== undefined) }
      }
    };
    rules.push(rule2);
  }
  return rules;
}

export function translateChangeTextFlex(tech, args, line, parsed, source, mapping, processed, config) {
  // do(change_text_flex,T,horizontal_start)
  let rules = [];
  let text_map = mapping[args[0]];
  let layer = source.layer?.[text_map?.layer];
  let text = layer?.text[text_map?.text];

  let rule = {
    category: "recommender",
    description: `Change the alignment of text lines`,
    specifier: {
    },
    action: "modify",
    option: {
    }
  }
  if (text) {
    rule.specifier.role = { "on-mark": "mark.label", "on-axis": "axis.label", "legend": "legend" }[text.type];
    if (text.name) rule.specifier.id = text.name;
    else if (text.field) rule.specifier.field = text.field;
    else rule.specifier.index = parseInt(text_map.text);
    if (layer) {
      rule.specifier.layer = {};
      if (layer.name) rule.specifier.layer.id = layer.name;
      else if (layer.mark?.type) rule.specifier.layer.mark = layer.mark.type;
      else rule.specifier.layer.index = text_map.layer;
    }
  }
  rule.option.flex = {
    horizontal: "horizontal",
    horizontal_start: "horizontal-start",
    horizontal_end: "horizontal-end",
    horizontal_center: "horizontal-center",
    horizontal_space_between: "horizontal-space-between",
    vertical: "vertical"
  }[args[1]];
  if (!text.width) rule.option.width = 40;
  rules.push(rule);
  return rules;
}


export function translateConvertTextOrient(tech, args, line, parsed, source, mapping, processed, config) {
  // do(convert_text_orient,T,left,serial,adjust)
  let rules = [];
  let text_map = mapping[args[0]];
  let layer = source.layer?.[text_map?.layer];
  let text = layer?.text[text_map?.text];
  let orient = args[1], isSerial = args[2] === "serial";
  let rule = {
    category: "recommender",
    description: `Change the orient and position of text lines`,
    specifier: {
    },
    action: "modify",
    option: {
    }
  }
  if (isSerial) {
    rule.option.serial = true;
  }
  if (text) {
    rule.specifier.role = { "on-mark": "mark.label", "on-axis": "axis.label", "legend": "legend" }[text.type];
    if (text.name) rule.specifier.id = text.name;
    else if (text.field) rule.specifier.field = text.field;
    else rule.specifier.index = parseInt(text_map.text);
    if (layer) {
      rule.specifier.layer = {};
      if (layer.name) rule.specifier.layer.id = layer.name;
      else if (layer.mark?.type) rule.specifier.layer.mark = layer.mark.type;
      else rule.specifier.layer.index = text_map.layer;
    }
  }
  rule.option.orient = orient;
  rules.push(rule);
  return rules;
}